import { render, staticRenderFns } from "./SpecChatCreatePopupWrappable.vue?vue&type=template&id=6e7c0218&scoped=true&lang=pug&"
import script from "./SpecChatCreatePopupWrappable.vue?vue&type=script&lang=js&"
export * from "./SpecChatCreatePopupWrappable.vue?vue&type=script&lang=js&"
import style0 from "./SpecChatCreatePopupWrappable.vue?vue&type=style&index=0&id=6e7c0218&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7c0218",
  null
  
)

export default component.exports